export default __webpack_public_path__ + "static/logo-3f68a865f9e488d47a06a97466b517db.svg";